import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-5 pb-5" }
const _hoisted_2 = { class: "info-container p-4 mt-4 mx-5" }
const _hoisted_3 = { class: "info-header d-flex justify-content-between" }
const _hoisted_4 = { class: "personal-form" }
const _hoisted_5 = { class: "row mb-3" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { for: "name" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { for: "phone" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-mail", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ds_header = _resolveComponent("ds-header")!
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ds_header, {
      hasButton: false,
      title: _ctx.$t('profile.title')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('profile.infor')), 1),
        _createVNode(_component_ds_button, {
          type: "primary",
          text: _ctx.$t('utils.save'),
          class: "float-start",
          form: "group-form",
          onClick: _ctx.sendUserInfo
        }, null, 8, ["text", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('profile.name')), 1),
              _createVNode(_component_InputText, {
                id: "name",
                name: "name",
                type: "text",
                class: "form-control",
                placeholder: _ctx.$t('profile.fullName'),
                modelValue: _ctx.userInfo.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userInfo.name) = $event)),
                required: ""
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('profile.phone')), 1),
              _createVNode(_component_InputMask, {
                id: "phone",
                name: "phone",
                class: "form-control",
                mask: "(99) 99999-9999",
                placeholder: "(99) 99999-9999",
                modelValue: _ctx.userInfo.phone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userInfo.phone) = $event)),
                required: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_InputText, {
                id: "email",
                name: "email",
                type: "text",
                class: "form-control",
                placeholder: "E-mail",
                modelValue: _ctx.userInfo.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userInfo.email) = $event)),
                disabled: "",
                required: ""
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ])
  ]))
}